export default __webpack_public_path__ + "static/media/explainer_search@2x.a7bf3214.png";